<template>
  <v-dialog
    v-model="showModal"
    persistent
    :max-width="getWidth"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="loading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2" v-if="!loading">
        <h3 style="word-break: break-word">{{ showTitle }}</h3>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-row>
          <v-col cols="12" class="py-0">
            <!-- search -->
            <services-modal-search
              :loading="loading"
              @search-modal="getClassifiers"
            />
          </v-col>
          <v-col cols="12" class="py-0">
            <!-- list -->
            <v-data-table
              class="mb-4 custom-table sticky-header"
              :loading="loading || paginationloading"
              :headers="headers"
              :items="itemList"
              :header-props="{
                sortByText: $t('Rūšiuoti pagal'),
              }"
              :footer-props="{
                showFirstLastPage: true,
                showCurrentPage: true,
                itemsPerPageText: $t('Rodyti po:'),
                itemsPerPageAllText: $t('visi'),
                itemsPerPageOptions: itemsPerPageOptions,
              }"
            >
              <!-- custom templates -->
                <template v-slot:item="{ item }">
                  <tr v-if="!itemIsAdded(item)">
                    <td class="text-left">
                      <div class="nowrap">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        dense
                        class="table-action mx-1"
                        v-bind="attrs"
                        v-on="on"
                        @click="addItem(item)"
                      >
                        mdi-plus
                      </v-icon>
                    </template>
                    <div class="tooltip-text">{{ $t('Pridėti') }}</div>
                  </v-tooltip>
                </div>
                    </td>
                    <td class="text-left">
                      <span>{{ item.text }}</span>
                    </td>
                  </tr>
                </template>
              <!-- basic templates -->
              <template slot="loading"> {{ $t('Kraunasi...') }} </template>
              <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
              <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
              <template #[`footer.page-text`]="props">
                {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
                {{ $t('iš') }}
                {{ props.itemsLength }}
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" class="py-0"
            ><h3>{{ $t('Pridėtos paslaugos') }}</h3></v-col
          >
          <v-col cols="12">
            <v-simple-table dense>
              <tbody>
                <tr v-for="subItem in addItemList" :key="subItem.value">
                  <td>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          dense
                          class="table-action mx-1"
                          v-bind="attrs"
                          v-on="on"
                          @click="deleteItem(subItem)"
                        >
                          mdi-delete-outline
                        </v-icon>
                      </template>
                      <div class="tooltip-text">{{ $t('Pašalinti') }}</div>
                    </v-tooltip>
                  </td>
                  <td>{{ subItem.text }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-col style="display: flex;" cols="12" class="py-0 pt-2">
            <el-text-field
              required
              label="IS identifikatorius"
              v-model="is_identificator"
              :maxlength="20"
            />
             <el-button
                style="height: 40px;"
                class="ml-1"
                title="Paieška"
                :loading="loading"
                color="primary"
                @click.native.stop="callSearchIsIdentificatorModal()"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <template>
          <el-button
            title="Atšaukti"
            :loading="loading"
            @click.native.stop="closeModal()"
            color="secondary"
          />
          <el-button
            title="Saugoti"
            :loading="loading"
            @click.native="confirmData()"
            color="primary"
          />
        </template>
      </v-card-actions>
    </v-card>
    <modal-search-is-identificator v-if="showSearchModal" @close-modal="closeSearchModal" />
  </v-dialog>
</template>

<script>
import { classifiersGet } from '@/services/classifierService.js'
import ServicesModalSearch from '@/views/classifiers/services/AdminServicesModalSearch.vue'
import ModalSearchIsIdentificator from './ModalSearchIsIdentificator.vue'

export default {
  name: 'ModalAddIsIdentificator',

  $_veeValidate: {
    validator: 'new',
  },
  components: {
    ServicesModalSearch,
    ModalSearchIsIdentificator,
  },
  data() {
    return {
      showSearchModal: false,
      is_identificator: '',
      itemList: [],
      addItemList: [],
      paginationloading: false,
      loading: false,
      itemsPerPageOptions: [10, 50, 100],
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'left',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Paslauga'),
          align: 'start',
          value: 'text',
        },
      ]
    },
    getWidth() {
      return '800px'
    },
    showTitle() {
      return 'Pridėti IS identifikatorių'
    },
    showModal() {
      return true
    },
  },
  created() {
    this.getClassifiers()
  },
  methods: {
    callSearchIsIdentificatorModal(){
      this.showSearchModal = true
    },
    closeSearchModal(item){
      if(item){
        this.is_identificator = item
      }
      this.showSearchModal = false
    },
    itemIsAdded(item) {
      return this.addItemList.find((element) => {
        if (item.value === element.value) {
          return true
        }
      })
    },
    addItem(item) {
      this.addItemList.push(item)
    },
    deleteItem(item) {
      const index = this.addItemList.findIndex((element) => {
        return item.value === element.value
      })
      if (index > -1) {
        this.addItemList.splice(index, 1)
      }
    },
    getClassifiers(mainSearch) {
      let search = []
      if (mainSearch) {
        Object.keys(mainSearch).map((key) => {
          if (key != 'isExpanded') {
            let obj = { key: key, value: mainSearch[key] }
            search.push(obj)
          }
        })
      }
      classifiersGet({ classifiers: ['action'], search: search })
        .then((res) => (this.itemList = res.data.classifiers['action'].lt))
        .catch((err) => this.$root.$emit('DATA_ERROR', err))
        .finally(() => {
          this.paginationloading = false
        })
    },
    closeModal() {
      this.$emit('close-modal')
    },
    cancel() {
      this.closeModal()
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
        pageSize: pagination.itemsPerPage,
        page: pagination.page,
        route: this.$route.name,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getClassifiers()
      }
    },
    confirmData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          let actions = []
          if (this.addItemList.length > 0) {
            this.addItemList.map((item) => {
              actions.push(item.value)
            })
          }
          let data = {
            actions: actions,
            is_identificator: this.is_identificator,
          }
          this.$axios
            .post(`actions/addIsIdentificator`, data)
            .then((res) => {
              this.closeModal()
            })
            .catch((err) => {
              err.response.data.fields = {
                actions:  this.$t("Paslaugos"),
              }
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {})
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
